import styled from '@emotion/styled'
import { Product } from '@news-mono/web-common'
import { breakpoint, calcRem, metrics, themedValue } from '../..'
import { StyledBauhausVideoCard } from '../../cards/BauhausVideoCard/BauhausVideoCard.styled'

export const StyledCarouselWrapper = styled('div')(({ theme }) => ({
    display: 'none',
    [breakpoint('md')]: {
        display: 'block',
    },
    position: 'absolute',
    right: 0,
    maxWidth: '40%',
    height: '100%',
}))

export const StyledCarousel = styled('div')(({ theme }) => ({
    display: 'none',
    height: themedValue(theme, {
        sevennews: '100%',
        fallback: undefined,
    }),
    [breakpoint('md')]:
        theme.kind === Product.PerthNow
            ? undefined
            : {
                  position: 'relative',
                  flex: 1,
                  display: 'flex',
                  overflowY: 'scroll',
                  flexDirection: 'column',
                  padding: calcRem(3, 10, 0, 10),
                  marginLeft: calcRem(15),
                  scrollBehavior: 'smooth',
              },
    '&::-webkit-scrollbar': {
        width: theme.kind === 'thewest' ? '8px' : undefined,
    },
    '&::-webkit-scrollbar-track': {
        background: theme.colors.components?.videoHub?.scrollBar?.track,
    },

    '&::-webkit-scrollbar-thumb': {
        background: theme.colors.components?.videoHub?.scrollBar?.thumb,
    },
}))

export const StyledCarouselWrapperWeb = styled('div')(({ theme }) => ({}))

export const StyledCarouselWrapperMobile = styled('div')(({ theme }) => ({
    position: 'relative',
    gridRowStart: 'span 2',
    marginTop: themedValue(theme, {
        sevennews: calcRem(40),
        fallback: calcRem(15),
    }),
    marginBottom: theme.kind === 'thewest' ? calcRem(8) : undefined,
    width:
        theme.kind === Product.PerthNow
            ? undefined
            : `calc(100vw - ${2 * metrics.sevennews.margins.md}px)`,
    paddingLeft: theme.kind === Product.PerthNow ? calcRem(8) : undefined,

    [breakpoint('sm')]: {
        width:
            theme.kind === Product.PerthNow
                ? undefined
                : `calc(100vw - ${2 * metrics.sevennews.margins.lg}px)`,
    },
    [breakpoint('md')]: {
        display: theme.kind === Product.PerthNow ? undefined : 'none',
    },
    [`${StyledBauhausVideoCard}`]: {
        maxWidth: theme.kind === 'thewest' ? calcRem(264) : calcRem(304),
    },
    '& .swiper': {
        paddingLeft: calcRem(3),
        marginRight: calcRem(-14),
        marginLeft: calcRem(-2),
        paddingBottom:
            theme.kind === Product.SevenNews ? calcRem(5) : undefined,
        height: theme.kind === Product.PerthNow ? '116px' : undefined,
    },
    '& .swiper-slide': {
        width: 'auto',
        marginTop: calcRem(3),
        minWidth: themedValue(theme, {
            sevennews: calcRem(304),
            fallback: undefined,
        }),
    },
}))
